"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var material_1 = require("@mui/material");
var Button_1 = __importDefault(require("../../button/Button"));
var react_1 = __importStar(require("react"));
var utils_1 = require("../utils/utils");
var utils_2 = require("../../../utils/utils");
var tableColumns = [
    { id: "code", label: "Code" },
    { id: "name", label: "Level of Care" },
    { id: "days", label: "Days/Sessions" },
    { id: "rate", label: "Rate per Day" },
    { id: "payment", label: "Include in Payment?" },
];
var LOCSummary = function (_a) {
    var handleLocModalOpen = _a.handleLocModalOpen, _b = _a.enableLOSbutton, enableLOSbutton = _b === void 0 ? true : _b, facilities = _a.facilities, selectedLevelsOfCare = _a.selectedLevelsOfCare, quoteMethod = _a.quoteMethod, _c = _a.vob, inNetwork = _c.inNetwork, isSelfPay = _c.isSelfPay, _d = _a.columnsToShow, columnsToShow = _d === void 0 ? ['code', 'name', 'days', 'rate', 'payment'] : _d;
    var _e = (0, react_1.useState)(0), locPage = _e[0], setLocPage = _e[1];
    var _f = (0, react_1.useState)(5), locRowsPerPage = _f[0], setLocRowsPerPage = _f[1];
    var levelsOfCareSummary = (0, utils_1.getFacilityLevelsOfCareSummary)(selectedLevelsOfCare, quoteMethod, inNetwork, isSelfPay);
    var handleLocChangePage = function (event, newPage) {
        setLocPage(newPage);
    };
    var handleChangeLocRowsPerPage = function (event) {
        setLocRowsPerPage(+event.target.value);
        setLocPage(0);
    };
    var blackOrRed = function (num) {
        if ((quoteMethod === "manual" ||
            quoteMethod === "sca") &&
            num === 0) {
            return react_1.default.createElement(material_1.Typography, { style: { color: "#ff0000", fontSize: "11pt" } }, num);
        }
        else {
            return react_1.default.createElement(react_1.default.Fragment, null, num);
        }
    };
    var coveredLOCData = levelsOfCareSummary.filter(function (row) { return row.covered; });
    var uncoveredLOCData = levelsOfCareSummary.filter(function (row) { return !row.covered; });
    var getTableCells = function (clonedColumnsToShow, row) {
        var isLocTypeOne = row.cfgLocType === 1;
        var cellWidth = "".concat(clonedColumnsToShow.length / 100, "%");
        return clonedColumnsToShow.map(function (column) {
            switch (column) {
                case 'code':
                    return (react_1.default.createElement(material_1.TableCell, { sx: { width: cellWidth } }, row === null || row === void 0 ? void 0 : row.code));
                case 'name':
                    return (react_1.default.createElement(material_1.TableCell, { sx: { width: cellWidth } }, row === null || row === void 0 ? void 0 :
                        row.name,
                        react_1.default.createElement("div", { style: { fontSize: "8pt" } }, utils_2.Utils.getFacilityName(row === null || row === void 0 ? void 0 : row.facilityId, facilities))));
                case 'days':
                    if (isLocTypeOne) {
                        return react_1.default.createElement(material_1.TableCell, { sx: { width: cellWidth } }, "-");
                    }
                    else {
                        return (react_1.default.createElement(material_1.TableCell, { sx: { width: cellWidth } }, blackOrRed(row === null || row === void 0 ? void 0 : row.days)));
                    }
                case 'rate':
                    if (isLocTypeOne) {
                        return react_1.default.createElement(material_1.TableCell, { sx: { width: cellWidth } }, "-");
                    }
                    else {
                        return (react_1.default.createElement(material_1.TableCell, { sx: { width: cellWidth } }, blackOrRed(row === null || row === void 0 ? void 0 : row.rate)));
                    }
                case 'payment':
                    return (react_1.default.createElement(material_1.TableCell, { sx: { width: cellWidth } },
                        react_1.default.createElement(material_1.FormGroup, null,
                            react_1.default.createElement(material_1.FormControlLabel, { control: react_1.default.createElement(material_1.Checkbox, { name: "includePayment", "aria-label": "includePayment", defaultChecked: isLocTypeOne, checked: isLocTypeOne, onChange: undefined }), label: undefined }))));
                default:
                    break;
            }
        });
    };
    var renderLOCDataTable = function (data, title, excludePayment, columnsToShow) {
        var locTableHeaders = [];
        var clonedColumnsToShow = __spreadArray([], columnsToShow, true);
        if (excludePayment)
            clonedColumnsToShow = clonedColumnsToShow.filter(function (col) { return col !== 'payment'; });
        clonedColumnsToShow.forEach(function (col) {
            var colLabel = tableColumns.find(function (colLabel) {
                return colLabel.id === col;
            });
            if (colLabel)
                locTableHeaders.push(colLabel);
        });
        return (react_1.default.createElement(material_1.TableContainer, { component: material_1.Paper },
            react_1.default.createElement(material_1.Table, { size: "small" },
                react_1.default.createElement(material_1.TableHead, null,
                    react_1.default.createElement(material_1.TableRow, { className: "levelOfCare-th" },
                        react_1.default.createElement(material_1.TableCell, { align: "center", colSpan: 5 }, title)),
                    react_1.default.createElement(material_1.TableRow, { className: "levelOfCare-sub-th" }, locTableHeaders.map(function (column) { return (react_1.default.createElement(material_1.TableCell, { key: column.id, sx: { width: "".concat(locTableHeaders.length / 100, "%") } }, column.label)); }))),
                react_1.default.createElement(material_1.TableBody, null, data.slice(locPage * locRowsPerPage, locPage * locRowsPerPage + locRowsPerPage).map(function (row, index) {
                    return (react_1.default.createElement(material_1.TableRow, { key: index }, getTableCells(clonedColumnsToShow, row)));
                }))),
            react_1.default.createElement(material_1.Grid, { container: true },
                react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
                    react_1.default.createElement(material_1.TablePagination, { component: "div", rowsPerPageOptions: [
                            5,
                            10,
                            50,
                            {
                                value: levelsOfCareSummary.length,
                                label: "All",
                            },
                        ], count: levelsOfCareSummary.length, rowsPerPage: locRowsPerPage, page: locPage, labelRowsPerPage: "View", onPageChange: handleLocChangePage, onRowsPerPageChange: handleChangeLocRowsPerPage })))));
    };
    return (react_1.default.createElement(material_1.Grid, { container: true, justifyContent: "flex-end" },
        react_1.default.createElement(material_1.Grid, { item: true, xs: 6, justifyContent: "flex-end", direction: "column", style: { textAlign: "right" } },
            react_1.default.createElement(Button_1.default, { onClick: function () { return handleLocModalOpen(); }, disabled: !enableLOSbutton }, selectedLevelsOfCare.length > 0 ? "Edit Levels of Care" : "Add Levels of Care")),
        react_1.default.createElement(material_1.Grid, { item: true, xs: 12, direction: "column", sx: { mt: 2 } },
            react_1.default.createElement(react_1.default.Fragment, null,
                coveredLOCData.length > 0 &&
                    renderLOCDataTable(coveredLOCData, "Covered Services", true, columnsToShow),
                react_1.default.createElement(material_1.Box, { my: 4 }),
                uncoveredLOCData.length > 0 &&
                    renderLOCDataTable(uncoveredLOCData, "Uncovered Services", !columnsToShow.some(function (col) { return col === 'payment'; }), columnsToShow)))));
};
exports.default = LOCSummary;
